import { getServerProps } from './serverProps';
import { isLoggedInUser, getUserType } from './authUtils';
import _includes from 'lodash/includes';

const serverProps = getServerProps();
const {
	userType
} = serverProps;

export const WIZARD_TOTAL_STEPS = isLoggedInUser(serverProps) && _includes(['BUSINESS', 'PREMIER'], userType) ? 4 : 3;

export function getNextStep(currentStep) {
	if (currentStep < WIZARD_TOTAL_STEPS) {
		return currentStep + 1;
	}
	return 1;
}

export function getPreviousStep(currentStep) {
	if (currentStep > 1) {
		return currentStep - 1;
	}
	return 1;
}

export function getNextPageUrl(currentPage, currentPath) {
	const nextPage = currentPage === WIZARD_TOTAL_STEPS ? 0 : currentPage + 1;

	return `${currentPath}?page=${nextPage}`;
}

export function getPreviousPageUrl(currentPage, currentPath) {
	const previousPage = currentPage === 1 ? 1 : currentPage - 1;

	return `${currentPath}?page=${previousPage}`;
}

export function getPageUrl(pageNumber, currentPath) {
	const page = pageNumber >= 1 && pageNumber <= WIZARD_TOTAL_STEPS ? pageNumber : 1;

	return `${currentPath}?page=${page}`;
}

export function isHostedFlow() {
	return _includes(['BUSINESS', 'PREMIER'], getUserType());
}



// WEBPACK FOOTER //
// ./buttons/utils/buttonFactoryUtils.js